import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import {
  CLEAR_SANTANDER_CLABE_OPTIONS,
  LOAD_SANTANDER_CLABES,
  SAVE_SANTANDER_CLABE_OPTIONS,
  LOAD_SANTANDER_PAYMENT_REPORTS,
  LOAD_SANTANDER_PAYMENT_REPORT_DETAILS
} from 'src/store/actions/santanderClabeActions';

const initialState = {
  items: [],
  count: 0,
  paymentDetails: [],
  paymentDetailsCount: 0,
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0,
    startDate: momentLocalTimezone().startOf('month').toDate(),
    endDate: momentLocalTimezone().endOf('month').toDate(),
    reconciliationStatus: null
  }
};

const santanderClabeReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SANTANDER_CLABES.start:
      return state;
    case LOAD_SANTANDER_CLABES.success:
      return {
        ...state,
        items: action.data.items,
        count: action.data.count
      };
    case LOAD_SANTANDER_CLABES.failure:
      return state;
    case LOAD_SANTANDER_PAYMENT_REPORTS.start:
      return state;
    case LOAD_SANTANDER_PAYMENT_REPORTS.success:
      return {
        ...state,
        items: action.data.items || [],
        count: action.data.count || 0
      };
    case LOAD_SANTANDER_PAYMENT_REPORTS.failure:
      return state;
    case SAVE_SANTANDER_CLABE_OPTIONS:
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    case LOAD_SANTANDER_PAYMENT_REPORT_DETAILS.success:
      return {
        ...state,
        paymentDetails: action.data.items || [],
        paymentDetailsCount: action.data.count || 0
      };

    case CLEAR_SANTANDER_CLABE_OPTIONS:
      return {
        ...state,
        options: initialState.options
      };

    default:
      return state;
  }
};

export default santanderClabeReducer;
